import { useNavigate } from 'react-router-dom';
import NotificationsView from '../components/screens/NotificationsView';
import { useNotificationsSummary } from '../contexts/NotificationsContext';
import useNotifications from '../hooks/useNotifications';

function NotificationsPage({ auth }) {
  const navigate = useNavigate();
  const { refreshNotificationSummary } = useNotificationsSummary();
  const {
    statusFilter,
    notifications,
    unreadCount,
    isLoadingNotifications,
    notificationsStatus,
    setStatusFilter,
    refreshNotifications,
    markNotificationRead,
    markNotificationUnread,
    buildNavigationPath,
  } = useNotifications(auth.currentUser, refreshNotificationSummary);

  const handleOpenNavigationTarget = (target) => {
    const path = buildNavigationPath(target);
    if (!path) {
      return;
    }

    navigate(path);
  };

  return (
    <NotificationsView
      notifications={notifications}
      unreadCount={unreadCount}
      statusFilter={statusFilter}
      notificationsStatus={notificationsStatus}
      isLoadingNotifications={isLoadingNotifications}
      onStatusFilterChange={setStatusFilter}
      onRefresh={() => refreshNotifications(statusFilter)}
      onOpenNavigationTarget={handleOpenNavigationTarget}
      onOpenQueue={(queueId) => navigate(`/queue/${queueId}`)}
      onMarkRead={markNotificationRead}
      onMarkUnread={markNotificationUnread}
    />
  );
}

export default NotificationsPage;
